import {
    type TCollectionSimple as TApiCollectionSimple,
    getAuthorCollectionUrl,
    withQuery,
} from '@core/api'
import { convertCollectionSimple } from '@core/converters'
import { httpClient } from '@core/http-client'

export const getCollectionSimple = async ({
    username,
    slug,
    signal,
}: {
    username: string
    slug: string
    signal?: AbortSignal
}) => {
    const apiCollection = await httpClient
        .get(withQuery(getAuthorCollectionUrl(username, slug), { simple: 1 }), { signal })
        .json<TApiCollectionSimple>()

    return convertCollectionSimple(apiCollection)
}
